import moment from 'moment'
import { getInsuranceQuoteKey } from './insuranceUtils'
import { FetchQuoteParams } from 'actions/InsuranceActions'

/**
 * For insurance purposes, when the departure and arrival dates are the same, we add one day to the end date.
 * This is necessary because insurance quotes cannot start and end on the same day.
 */
function sanitazeEndDate(departingDate?: string, arrivalDate?: string) {
  return departingDate === arrivalDate ?
    moment(arrivalDate).add(1, 'day').format('YYYY-MM-DD') :
    arrivalDate
}

export function getInsuranceQuoteParams(departingDate?: string, arrivalDate?: string, coverAmount?: number, destinationCountries?: Array<string>, occupancies?: App.Occupants) {
  const endDate = sanitazeEndDate(departingDate, arrivalDate)

  return {
    type: 'booking-protection',
    productId: 'CFMR',
    startDate: departingDate,
    endDate,
    coverAmount,
    destinationCountries,
    travellers: occupancies,
  } as FetchQuoteParams
}

export function getFlighSearchInsuranceQuoteKey(departingDate?: string, arrivalDate?: string, coverAmount?: number, destinationCountry?: string, occupancies?: App.Occupants) {
  return getInsuranceQuoteKey('CFMR', getInsuranceQuoteParams(departingDate, arrivalDate, coverAmount, destinationCountry ? [destinationCountry] : [], occupancies))
}

export const FLIGHT_INSURANCE_ID_PREFIX = '-insurance'

export function restoreIdsOfInsuranceFareFamily(fareFamily: App.FlightFareFamily): App.FlightFareFamily {
  return {
    ...fareFamily,
    id: fareFamily.id.replace(new RegExp(`${FLIGHT_INSURANCE_ID_PREFIX}.*$`), ''),
    ...(
      Array.isArray(fareFamily.pairedUpsellIds) && fareFamily.pairedUpsellIds.length > 0 ? {
        pairedUpsellIds: [...new Set(fareFamily.pairedUpsellIds.map(id => id.replace(new RegExp(`${FLIGHT_INSURANCE_ID_PREFIX}.*$`), '')))],
      } : {}
    ),
  }
}
